module.exports = __webpack_public_path__ + "static/media/reminder.ecaf4209.jpg";